const SUSEProducts = Object.freeze({
    OPENSUSE:   Symbol("openSUSE"),
    SLES4SAP:  Symbol("SLES4SAP"),
    SLES: Symbol("SLES"),
    getByName: function(name) {
        switch (name) {
            case 'SLES4SAP':
                return this.SLES4SAP
            case 'SLES':
                return this.SLES
            case 'OPENSUSE':
            default:
                return this.OPENSUSE
        }
    }
});

export default SUSEProducts
